import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { IAttributeConfData } from '@df/catalog-ui/product/configurable-options/product-configurable-options.component.def';
import { DfImageDirective } from '@df/module-image/df-image.directive';
import { DragScrollDirective } from '@df/ui/common/drag-scroll.directive';
import { ProductConfigurableOptionsAbstract } from '../product-configurable-options.abstract';

@Component({
    selector: 'product-configurable-options-swatch',
    templateUrl: './product-configurable-options-swatch.component.html',
    styleUrl: './product-configurable-options-swatch.component.scss',
    standalone: true,
    imports: [CommonModule, DfImageDirective, DragScrollDirective],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProductConfigurableOptionsSwatchComponent extends ProductConfigurableOptionsAbstract {
    protected override setAttributes(attributes: IAttributeConfData[] | undefined) {
        this.attributes = attributes?.filter(i => this.isSwatchTypeAttribute(i)) || [];
    }
}
